<template>
  <div class="container-xxl business-detail-page py-5" v-if="firma">
    <div class="container">
      <router-link to="/firmalar" class="business-back-link">
        <i class="fa fa-arrow-left"></i>
        Firmalara dön
      </router-link>

      <div class="business-detail-hero">
        <div>
          <h6 class="section-title text-start text-primary text-uppercase">Firma Detayı</h6>
          <h1>{{ firma.title }}</h1>
          <p>{{ firma.desciption }}</p>
        </div>
        <div class="business-detail-actions">
          <a :href="`tel:${normalizePhone(firma.phone)}`" class="btn btn-primary">
            <i class="fa fa-phone-alt me-2"></i>Ara
          </a>
          <a v-if="hasWhatsapp(firma.phone)" :href="getWhatsappUrl(firma)" target="_blank" rel="noopener" class="btn btn-success">
            <i class="fab fa-whatsapp me-2"></i>WhatsApp
          </a>
          <a :href="firma.location" target="_blank" rel="noopener" class="btn btn-dark">
            <i class="fa fa-map-marker-alt me-2"></i>Konum
          </a>
        </div>
      </div>

      <div class="business-detail-grid">
        <section class="business-detail-panel">
          <h2>Firma bilgileri</h2>
          <div class="business-detail-list">
            <div>
              <i class="fa fa-user"></i>
              <span>Yetkili</span>
              <strong>{{ firma.contact }}</strong>
            </div>
            <div>
              <i class="fa fa-phone-alt"></i>
              <span>Telefon</span>
              <a :href="`tel:${normalizePhone(firma.phone)}`">{{ firma.phone }}</a>
            </div>
            <div>
              <i class="fa fa-map-marker-alt"></i>
              <span>Adres</span>
              <strong>{{ firma.adress }}</strong>
            </div>
          </div>
        </section>

        <aside class="business-detail-panel">
          <h2>Kategoriler</h2>
          <div class="business-detail-tags">
            <span v-for="kategori in parseKategori(firma.category)" :key="kategori">
              {{ kategori }}
            </span>
          </div>
          <p>
            {{ firma.title }}; Ankara'daki Ağrılı firmalar, hemşehri esnaflar ve güvenilir
            hizmet ağı içinde tanıtılmaktadır. Hizmet almak için telefonla arayabilir,
            WhatsApp üzerinden mesaj gönderebilir veya konum bilgisiyle firmaya ulaşabilirsiniz.
          </p>
        </aside>
      </div>
    </div>
  </div>

  <div class="container py-5" v-else>
    <div class="business-empty-detail">
      <h1>Firma bulunamadı</h1>
      <router-link to="/firmalar" class="btn btn-primary">Firmalara dön</router-link>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { ref } from 'vue';
import FIRMALAR from '@/data/firmalar';
import slugify from '@/utils';

const route = useRoute();
const slug = route.params.slug;
const firma = ref(null);

firma.value = FIRMALAR.find((item) => slugify(item.title) === slug);

function parseKategori(raw) {
  if (!raw) return [];
  return raw.split(',').map((item) => item.trim()).filter(Boolean);
}

function normalizePhone(phone) {
  return String(phone || '').replace(/\s/g, '');
}

function normalizeWhatsappPhone(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (digits.startsWith('90')) return digits;
  if (digits.startsWith('0')) return `90${digits.slice(1)}`;
  return `90${digits}`;
}

function hasWhatsapp(phone) {
  return normalizePhone(phone).replace(/\D/g, '').replace(/^90/, '').replace(/^0/, '').startsWith('5');
}

function getWhatsappUrl(item) {
  const message = `Merhaba, Ankara Ağrılılar Derneği web sitesinde ${item.title} firmanızı gördüm. Hizmetleriniz hakkında bilgi almak istiyorum.`;
  return `https://wa.me/${normalizeWhatsappPhone(item.phone)}?text=${encodeURIComponent(message)}`;
}
</script>

<style scoped>
.business-detail-page {
  background: linear-gradient(180deg, #FFFFFF 0%, #F7FAFC 52%, #FFFFFF 100%);
}

.business-back-link {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  color: var(--dark);
  font-weight: 700;
  margin-bottom: 24px;
}

.business-back-link:hover {
  color: var(--primary);
}

.business-detail-hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 28px;
  align-items: end;
  background: #FFFFFF;
  border: 1px solid rgba(15, 23, 43, .08);
  border-left: 4px solid var(--primary);
  border-radius: 8px;
  padding: 34px;
  box-shadow: 0 16px 38px rgba(15, 23, 43, .08);
}

.business-detail-hero h1 {
  color: var(--dark);
  font-size: clamp(32px, 4vw, 52px);
  line-height: 1.08;
  margin: 0 0 18px;
}

.business-detail-hero p {
  color: #5B6475;
  font-size: 18px;
  line-height: 1.75;
  margin: 0;
}

.business-detail-actions {
  display: flex;
  gap: 10px;
}

.business-detail-actions .btn {
  min-height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 10px 20px;
}

.business-detail-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 330px;
  gap: 24px;
  margin-top: 24px;
}

.business-detail-panel {
  background: #FFFFFF;
  border: 1px solid rgba(15, 23, 43, .08);
  border-radius: 8px;
  padding: 28px;
  box-shadow: 0 12px 30px rgba(15, 23, 43, .06);
}

.business-detail-panel h2 {
  color: var(--dark);
  font-size: 24px;
  margin-bottom: 18px;
}

.business-detail-panel p {
  color: #606A7A;
  line-height: 1.7;
  margin: 18px 0 0;
}

.business-detail-list {
  display: grid;
  gap: 12px;
}

.business-detail-list div {
  display: grid;
  grid-template-columns: 34px 110px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  background: #F8FAFC;
  border: 1px solid rgba(15, 23, 43, .06);
  border-radius: 8px;
  padding: 14px;
}

.business-detail-list i {
  color: var(--primary);
}

.business-detail-list span {
  color: #697386;
  font-weight: 700;
}

.business-detail-list strong,
.business-detail-list a {
  color: var(--dark);
  font-weight: 700;
  overflow-wrap: anywhere;
}

.business-detail-list a:hover {
  color: var(--primary);
}

.business-detail-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.business-detail-tags span {
  color: #7A4C00;
  background: #FFF4DF;
  border: 1px solid #FFE2AA;
  font-size: 13px;
  font-weight: 700;
  padding: 8px 10px;
  border-radius: 999px;
}

.business-empty-detail {
  background: #FFFFFF;
  border: 1px solid rgba(15, 23, 43, .08);
  border-radius: 8px;
  padding: 34px;
  text-align: center;
}

@media (max-width: 991.98px) {
  .business-detail-hero,
  .business-detail-grid {
    grid-template-columns: 1fr;
  }

  .business-detail-actions {
    flex-wrap: wrap;
  }
}

@media (max-width: 575.98px) {
  .business-detail-page {
    padding-bottom: 86px !important;
  }

  .business-detail-hero,
  .business-detail-panel {
    padding: 22px;
  }

  .business-detail-hero h1 {
    font-size: 32px;
  }

  .business-detail-hero p {
    font-size: 16px;
  }

  .business-detail-actions .btn {
    width: 100%;
  }

  .business-detail-list div {
    grid-template-columns: 28px minmax(0, 1fr);
  }

  .business-detail-list strong,
  .business-detail-list a {
    grid-column: 2;
  }
}
</style>
